import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TableData } from '../ga4-metrics.interface';
import { GaTableColumnConfig } from './interface';

const defaultRowsToDisplay = 4;

@Component({
  selector: 'app-ga-table',
  templateUrl: './ga4-table.component.html',
  styleUrls: ['./ga4-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class Ga4TableComponent {
  tableData: TableData[];
  @Input() dataType: 'number' | 'string' | 'percentage';
  @Input() columnConfig: GaTableColumnConfig;
  showAllRows = false;
  amountOfRowsToDisplay: number;
  totalRows: number;
  nameDataIndex = 0;
  valueDataIndex = 1;

  @Input()
  set sourceData(tableData: TableData[]) {
    this.tableData = tableData;
    this.totalRows = tableData ? tableData.length : 0;
    this.amountOfRowsToDisplay = defaultRowsToDisplay;
  }

  toggleShowAllRows(): void {
    this.showAllRows = !this.showAllRows;
    this.amountOfRowsToDisplay = this.showAllRows ? this.totalRows : defaultRowsToDisplay;
  }
}
